const INFO = {
	main: {
		title: "Olamide's Portfolio",
		name: "Idowu Olamide",
		email: "idowuolamide81@gmail.com",
		logo: "../logoo.png",
	},

	socials: {
		twitter: "https://twitter.com/just_olaa_",
		github: "https://github.com/justolaa/justolaa.github.io",
		linkedin: "www.linkedin.com/in/idowu-olamide",
		instagram: "https://instagram.com/just_ola__/",
		hashnode: "https://hashnode.com/@Justola",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Front-End Web Developer",
		description:
			"I perceive myself as a magician of the web, conjuring up amazing user interfaces with my expertise in Javascript, React.js and SQL. I have mastered the art of building web applications that can handle the weight of the world, while ensuring they are as secure as Fort Knox. I thrive on unraveling complex problems, like a modern-day Sherlock Holmes, and I never shy away from picking up new skills along the way. Quality and cleanliness are my obsessions when it comes to code, I treat it like a fine work of art that adheres to the strictest industry standards.",
	},

	about: {
		title: "Olamide is a Nigerian that is keen on learning and exploring new technologies",
		description:
			"Over the years, I've worked on many different projects, and I'm proud of the advancements I've made. Numerous of these initiatives are open-source and accessible to others for exploration and participation. Please feel free to look over the code for any of the projects I've worked on if you're interested in them and offer any suggestions you may have for enhancements or changes. I'm always open to fresh perspectives and criticism, and working with others is a fantastic opportunity to learn and develop.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Interactive 3D Book Slider",
			description:
				"An immersive 3D book showcase built with React, Vite, and Three.js. Designed to bring stories to life with smooth animations and intuitive interactions. This project highlights my skills in combining 3D visuals with responsive web design.",
			logo: "./threejs-logo.png",
			linkText: "View Project",
			link: "https://olamide-2024.vercel.app/",
		},
		{
			title: "Glosfabrics",
			description:
				"A modern e-commerce website for Glosfabrics, featuring secure authentication, robust CRUD operations, real-time analytics, and an AI-powered chatbot for customer support. Built with Vite + React, Firebase, it ensures seamless user experiences and backend security.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://glosfabrics.web.app/",
		},

			{
			title: "Calculator",
			description:
				"A user friendly calculator that also has three aesthetically pleasing themes.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://justolaa.github.io/Day20/Day20.html",
		},

			{
			title: "Virid Food",
			description:
				"A dynamic e-commerce platform with seamless authentication, full CRUD capabilities, built-in analytics, and optimized for search engines—crafted for performance and user experience.",
			logo: "./virid.png",
			linkText: "View Project",
			link: "https://virid-food-concept.web.app/",
		},

		{
			title: "E-commerce Website",
			description:
				"Clone of an E-commerce website built with React.js",
				logo: "./react.png",
			linkText: "View Project",
			link: "https://justolaa.github.io/E-commerce-Project",
		},

		{
			title: "Puzzler Game",
			description:
				"This project was designed for Neoxian City, a hub of creativity and collaboration within the Hive blockchain.  ",
			logo: "https://cryptologos.cc/logos/hive-blockchain-hive-logo.png",
			linkText: "View Project",
			link: "https://neoxian-city-puzzler.vercel.app/",
		},

		{
			title: "2048-Game",
			description:
				"An engaging 2048 game featuring a global leaderboard, seamless gameplay, and optimized for performance.",
			logo: "https://2048-game-two-alpha.vercel.app/floating-tile.png",
			linkText: "View Project",
			link: "https://2048-game-two-alpha.vercel.app/",
		},
	],
};

export default INFO;
